import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import Slider from "react-slick";
import slugify from "slugify";

import ErrorHandler from "@/components/ErrorHandler";
import EditorialCard from "@/components/cards/editorial-card-2-column";
import withScreenDimensions from "@/utils/helpers/screen_dimensions";

import styles from "./index.module.scss";

const ElevatedExperienceModule = ({ id, data, isDesktop, isMobile }) => {
  try {
    const sectionSlug = slugify(get(data, "subNavLabel", id)).toLowerCase();

    return (
      <section
        className={`${styles.elevatedExperience} module container`}
        id={sectionSlug}
      >
        <div className="row">
          <div className="col-md-5">
            <h2 className={styles.header}>{data.header}</h2>
          </div>
        </div>
        <div className="row">
          {isDesktop &&
            data.experiences.map(
              ({
                sys: { id },
                fields: {
                  media: { fields: mediaFields },
                  title,
                  subcopy,
                },
              }) => {
                return (
                  <div className={`${styles.card} col-md-4`} key={id}>
                    <EditorialCard
                      colIndex={0}
                      id={id}
                      key={id}
                      mediaFields={mediaFields}
                      subcopy={subcopy}
                      title={title}
                    />
                  </div>
                );
              }
            )}

          {!isDesktop && (
            <Slider
              arrows={false}
              centerMode={false}
              centerPadding="10%"
              className="col"
              dots={false}
              infinite={false}
              slidesToScroll={1}
              slidesToShow={isMobile ? 1.25 : 2.25}
              speed={500}
            >
              {data.experiences.map(
                ({
                  sys: { id },
                  fields: {
                    media: { fields: mediaFields },
                    title,
                    subcopy,
                  },
                }) => (
                  <EditorialCard
                    colIndex={0}
                    id={id}
                    key={id}
                    mediaFields={mediaFields}
                    subcopy={subcopy}
                    title={title}
                  />
                )
              )}
            </Slider>
          )}
        </div>
      </section>
    );
  } catch (error) {
    return (
      <ErrorHandler componentName="ElevatedExperienceModule" error={error} />
    );
  }
};

ElevatedExperienceModule.propTypes = {
  data: PropTypes.shape({
    experiences: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          media: PropTypes.shape({
            fields: PropTypes.shape({
              imageAltText: PropTypes.string.isRequired,
              imageFile: PropTypes.shape({
                fields: PropTypes.shape({
                  file: PropTypes.shape({
                    url: PropTypes.string.isRequired,
                  }).isRequired,
                }).isRequired,
              }).isRequired,
            }).isRequired,
          }).isRequired,
          subCopy: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
        }).isRequired,
        sys: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }).isRequired,
      })
    ).isRequired,
    header: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  isDesktop: PropTypes.string.isRequired,
  isMobile: PropTypes.string.isRequired,
};

export default withScreenDimensions(ElevatedExperienceModule);
